<template>
    <div v-if="!params.readOnly">
        <b-button variant="default" class="mr-1" @click="showCreateModal">
            <font-awesome-icon :icon="['fas', 'plus']" />
        </b-button>
        <b-button variant="default" class="mr-1" @click="showEditModal">
            <font-awesome-icon :icon="['fas', 'pen-to-square']" />
        </b-button>
        <b-button
            v-if="!params.data.default"
            variant="default"
            class="mr-1"
            @click="$bvModal.show(removeSeasonModalId)"
        >
            <font-awesome-icon :icon="['fas', 'trash']" />
        </b-button>
        <modal :id="removeSeasonModalId" title="Warning" @ok.prevent="onRemoveSeason">
            <busy-modal :show="loading" />
            Are you sure you want to delete this season?
        </modal>
        <create-edit-season-modal
            :title="createEditModalTitle"
            :rateId="params.data.id"
            :currentYear="params.currentYear"
            :initValues="values"
            :maxGuests="params.maxGuests"
            :modalId="createEditModalId"
            :objects="rates"
            :rateSettings="rateSettings"
            :ruleSettings="ruleSettings"
            :isDefault="params.data.default"
            :loading="loading"
            :editMode="editMode"
            :newObject="newSeasonObject"
            :isSeasonality="true"
            :lastObject="lastObject"
            @submit="createEditSeason"
            @reset="onReset"
            @delete="onRemoveSeasonFromModal"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import clone from 'lodash/clone';
    import isObject from 'lodash/isObject';
    import Modal from '../../generic/modal/modal.vue';
    import BusyModal from '../../generic/busy-modal/busy-modal.vue';
    import FormInput from '../../generic/form-input/form-input.vue';
    import FormCheckbox from '../../generic/form-checkbox/form-checkbox.vue';
    import FormDatepicker from '../../generic/form-datepicker/form-datepicker.vue';
    import FormSelect from '../../generic/form-select/form-select.vue';
    import CreateEditSeasonModal from '../../common/create-edit-rate-season-modal.vue';
    import { templatesMixin } from '../mixins/templates-mixin';

    export default {
        components: {
            Modal,
            BusyModal,
            FormInput,
            FormDatepicker,
            FormCheckbox,
            FormSelect,
            CreateEditSeasonModal,
        },
        mixins: [templatesMixin],
        data() {
            return {
                loading: null,
                editMode: false,
                values: null,
            };
        },
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat']),
            removeSeasonModalId() {
                return 'remove-season-' + this.params.data?.id;
            },
            createEditModalId() {
                return 'create-edit' + this.params.data?.id;
            },
            createEditModalTitle() {
                return this.editMode ? 'Edit Rate' : 'Add Rate';
            },
            rates() {
                return this.params.rates || [];
            },
            rateSettings() {
                return this.params.rateSettings;
            },
            ruleSettings() {
                return this.params.ruleSettings;
            },
        },
        methods: {
            onRemoveSeasonFromModal(id) {
                this.$bvModal.hide(this.createEditModalId);
                this.$bvModal.show('remove-season-' + id);
            },
            async onRemoveSeason(id) {
                let seasonId = id;
                if (isObject(seasonId)) {
                    const modalId = id.componentId;
                    seasonId = modalId.split('-').length === 2 ? modalId.split('-')[2] : 0;
                }
                this.params?.removeSeason(seasonId || this.params.data.id);
            },
            showEditModal() {
                this.editMode = true;
                this.values = this.getInitialValues(true);
                this.$bvModal.show(this.createEditModalId);
            },
            showCreateModal() {
                this.editMode = false;
                this.values = this.getInitialValues(false);
                this.$bvModal.show(this.createEditModalId);
            },
            async createEditSeason(values) {
                this.loading = true;
                await this.params.createEditSeason(this.editMode, values);
                this.loading = false;
            },
            onReset() {
                const period = clone(this.values.period);
                this.lastObject = null;
                this.values = JSON.parse(JSON.stringify(this.newSeasonObject));
                this.values.period = period;
            },
            getInitialValues(isEdit) {
                const values = JSON.parse(JSON.stringify(this.params.data));
                return isEdit
                    ? JSON.parse(
                          JSON.stringify({
                              ...values,
                              weekend_rate: values.weekend_rate || values.daily_rate,
                              weekly_rate: values.weekly_rate || '0.00',
                              monthly_rate: values.monthly_rate || '0.00',
                              arrival_day: values.arrival_day || 0,
                              departure_day: values.departure_day || 0,
                              extra_person_rate: values.extra_person_rate || '0.00',
                          })
                      )
                    : JSON.parse(
                          JSON.stringify({
                              ...this.newSeasonObject,
                          })
                      );
            },
        },
    };
</script>

<style lang="scss" scoped>
    .rate-season-form {
        min-height: 400px;
    }
</style>
